/**
 * This is a base for our modules, provides an option to make the module
 * publically accessible.
 *
 * @export
 * @class BaseModule
 */
export class BaseModule {
    public isPublic = false;


    /**
     * Makes the module publicly accessible 
     * 
     * @param {string} key 
     * @memberof BaseModule
     */
    makePublic(key: string): void {
        this.isPublic = true;
        window.app.modules[key] = this;
    }
}